import { useTranslation } from 'react-i18next'
import { LandingFrame } from '../features/landing/ui/LandingFrame'
import { LandingDetailHero } from '../features/landing/ui/LandingDetailHero'
import { CoverageSection } from '../features/landing/ui/CoverageSection'
import { AnalyticsPreviewSection } from '../features/landing/ui/AnalyticsPreviewSection'
import { PricingSection } from '../features/landing/ui/PricingSection'

export function LandingPlatformPage() {
  const { t } = useTranslation()

  return (
    <LandingFrame>
      <LandingDetailHero
        badge={t('landing.pages.platform.badge')}
        title={t('landing.pages.platform.title')}
        subtitle={t('landing.pages.platform.subtitle')}
        highlights={[
          t('landing.pages.platform.highlights.1'),
          t('landing.pages.platform.highlights.2'),
          t('landing.pages.platform.highlights.3'),
        ]}
        visual={
          <div className="rounded-2xl border border-border/70 bg-card/80 p-5 shadow-[0_0_32px_var(--glow-brand)] backdrop-blur">
            <div className="mb-3 text-xs text-muted-foreground">
              {t('landing.pages.platform.visualTitle')}
            </div>
            <div className="space-y-3">
              <div className="rounded-xl border border-border/70 bg-background/65 p-3">
                <div className="text-[11px] text-muted-foreground">
                  {t('landing.pages.platform.visualCards.1.title')}
                </div>
                <div className="mt-1 text-sm font-medium text-foreground">
                  {t('landing.pages.platform.visualCards.1.description')}
                </div>
              </div>
              <div className="rounded-xl border border-border/70 bg-background/65 p-3">
                <div className="text-[11px] text-muted-foreground">
                  {t('landing.pages.platform.visualCards.2.title')}
                </div>
                <div className="mt-1 text-sm font-medium text-foreground">
                  {t('landing.pages.platform.visualCards.2.description')}
                </div>
              </div>
              <div className="rounded-xl border border-border/70 bg-background/65 p-3">
                <div className="text-[11px] text-muted-foreground">
                  {t('landing.pages.platform.visualCards.3.title')}
                </div>
                <div className="mt-1 text-sm font-medium text-foreground">
                  {t('landing.pages.platform.visualCards.3.description')}
                </div>
              </div>
            </div>
          </div>
        }
      />
      <CoverageSection />
      <AnalyticsPreviewSection />
      <PricingSection />
    </LandingFrame>
  )
}
